export default {

  list() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByName('search')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_platform_settings'
          form_element.submit()
        })
      })

    }, false)
  },
}
